var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2950: function() { return loadSingletonVersionCheckFallback("default", "react", [1,17,0,2], function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); }); },
	2181: function() { return loadSingletonVersionCheckFallback("default", "react-dom", [1,17,0,2], function() { return __webpack_require__.e(164).then(function() { return function() { return __webpack_require__(4164); }; }); }); },
	3427: function() { return loadStrictVersionCheckFallback("default", "mobx", [1,6,5,0], function() { return __webpack_require__.e(98).then(function() { return function() { return __webpack_require__(4098); }; }); }); },
	6563: function() { return loadStrictVersionCheckFallback("default", "styled-components", [1,5,3,5], function() { return __webpack_require__.e(31).then(function() { return function() { return __webpack_require__(6031); }; }); }); },
	253: function() { return loadStrictVersionCheckFallback("default", "@descomplica/microfrontend-mvvm", [4,1,0,3], function() { return Promise.all([__webpack_require__.e(427), __webpack_require__.e(505), __webpack_require__.e(320)]).then(function() { return function() { return __webpack_require__(7320); }; }); }); },
	7654: function() { return loadStrictVersionCheckFallback("default", "mobx-react", [1,7,3,0], function() { return Promise.all([__webpack_require__.e(907), __webpack_require__.e(427)]).then(function() { return function() { return __webpack_require__(8907); }; }); }); },
	1505: function() { return loadStrictVersionCheckFallback("default", "tsyringe", [1,4,6,0], function() { return __webpack_require__.e(174).then(function() { return function() { return __webpack_require__(4174); }; }); }); },
	194: function() { return loadStrictVersionCheckFallback("default", "@descomplica/uee-ui-components", [1,8,27,2], function() { return __webpack_require__.e(817).then(function() { return function() { return __webpack_require__(9817); }; }); }); },
	1678: function() { return loadSingletonVersionCheckFallback("default", "@descomplica/caching-browser", [1,1,0,5], function() { return function() { return __webpack_require__(2962); }; }); },
	3775: function() { return loadStrictVersionCheckFallback("default", "fuse.js", [1,6,6,2], function() { return __webpack_require__.e(137).then(function() { return function() { return __webpack_require__(2137); }; }); }); },
	5159: function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [1,6,3,0], function() { return __webpack_require__.e(677).then(function() { return function() { return __webpack_require__(6677); }; }); }); },
	5702: function() { return loadStrictVersionCheckFallback("default", "@descomplica/uee-freemium-mf-base", [1,8,30,4], function() { return __webpack_require__.e(878).then(function() { return function() { return __webpack_require__(4878); }; }); }); },
	5944: function() { return loadStrictVersionCheckFallback("default", "@xyflow/react", [1,12,9,2], function() { return __webpack_require__.e(324).then(function() { return function() { return __webpack_require__(1324); }; }); }); },
	6218: function() { return loadStrictVersionCheckFallback("default", "reflect-metadata", [2,0,1,13], function() { return __webpack_require__.e(121).then(function() { return function() { return __webpack_require__(1389); }; }); }); },
	6450: function() { return loadStrictVersionCheckFallback("default", "@descomplica/presentation-service-base", [3,0,0,7], function() { return Promise.all([__webpack_require__.e(522), __webpack_require__.e(114)]).then(function() { return function() { return __webpack_require__(7522); }; }); }); },
	6874: function() { return loadStrictVersionCheckFallback("default", "@descomplica/design-system-react", [4,1,0,11], function() { return __webpack_require__.e(22).then(function() { return function() { return __webpack_require__(3022); }; }); }); },
	7405: function() { return loadStrictVersionCheckFallback("default", "@descomplica/microfrontend-react", [4,1,0,1], function() { return Promise.all([__webpack_require__.e(606), __webpack_require__.e(452)]).then(function() { return function() { return __webpack_require__(4716); }; }); }); },
	7610: function() { return loadStrictVersionCheckFallback("default", "react-toastify", [1,9,1,1], function() { return __webpack_require__.e(193).then(function() { return function() { return __webpack_require__(9085); }; }); }); },
	9985: function() { return loadStrictVersionCheckFallback("default", "date-fns", [1,2,30,0], function() { return __webpack_require__.e(815).then(function() { return function() { return __webpack_require__(8815); }; }); }); },
	8606: function() { return loadSingletonVersionCheckFallback("default", "@descomplica/microfrontend-core", [0,0,0,1,,"beta",0], function() { return function() { return __webpack_require__(5208); }; }); },
	7114: function() { return loadSingletonVersionCheckFallback("default", "@descomplica/caching-browser", [1,1,0,3], function() { return function() { return __webpack_require__(2962); }; }); },
	1082: function() { return loadSingletonVersionCheckFallback("default", "@descomplica/caching-browser", [0,0,0,1], function() { return function() { return __webpack_require__(2962); }; }); }
};
var initialConsumes = [1082];
initialConsumes.forEach(function(id) {
	__webpack_require__.m[id] = function(module) {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"114": [
		7114
	],
	"181": [
		2181
	],
	"218": [
		194,
		1678,
		3775,
		5159,
		5702,
		5944,
		6218,
		6450,
		6874,
		7405,
		7610,
		9985
	],
	"427": [
		3427
	],
	"505": [
		1505
	],
	"563": [
		6563
	],
	"606": [
		8606
	],
	"921": [
		253,
		7654
	],
	"950": [
		2950
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}